import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';
import PasswordInput from '../../components/ui/PasswordInput';

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Connexion réussie');
      navigate('/admin/surveys');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Identifiants invalides');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-2xl font-bold text-gray-800 mb-6 text-center">
            Connexion Admin
          </h1>
          <form onSubmit={handleSubmit} className="space-y-4" aria-label="Connexion administrateur">
            <div>
              <label htmlFor="admin-login-email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                id="admin-login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                aria-required="true"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent min-h-[44px]"
                placeholder="admin@barometre.local"
              />
            </div>
            <PasswordInput
              id="admin-login-password"
              label="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              aria-required="true"
              placeholder="••••••••"
            />
            <button
              type="submit"
              disabled={loading}
              aria-busy={loading}
              className="w-full py-2 px-4 min-h-[44px] bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 disabled:opacity-50 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
          <p className="mt-4 text-sm text-gray-500 text-center">
            <Link to="/forgot-password" className="text-primary-600 hover:underline block mb-2">
              Mot de passe oublié ?
            </Link>
            Démo : admin@barometre.local / password
          </p>
        </div>
      </div>
    </div>
  );
}
